$(document).on("click", "#drawer-toggle", function (e) {
      $('#menu-drawer').addClass('open');
      $('.custom_overlay').addClass('active');
    });
$(document).on("click", "#drawer-close", function (e) {
      $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
    });

    // Optional: Close on clicking outside
$(document).on("click", function (e) {
      if (!$(e.target).closest('#menu-drawer, #drawer-toggle').length) {
        $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
      }
    });

// Toggle drawer
$(document).on("click", "#cart-toggle", function (e) {
      $('#cart-drawer').addClass('open');
      $('.custom_overlay2').addClass('active');
    });

$(document).on("click", "#cart-close,.cart_empty_button", function (e) {
      $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
    });

    // Optional: Click outside to close
    $(document).on('click', function (e) {
      if (!$(e.target).closest('#cart-drawer, #cart-toggle').length) {
        $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
      }
    });




  function refreshCartDrawer() {
    $.ajax({
      url: window.location.pathname, // reload current page
      type: 'GET',
      dataType: 'html',
      success: function (data) {
        const $newDrawer = $(data).find('#cart_drawer_content');
        $('#cart_drawer_content').replaceWith($newDrawer);
      }
    });
  }


 function updateCart(variantId, quantity, key, sellingPlan = null) {
    const payload = {
      id: key,
      quantity: quantity
    };

    if (sellingPlan) {
      payload.selling_plan = sellingPlan;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify(payload),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        refreshCartDrawer();
      },
      error: function (xhr) {
        console.error('Cart update failed:', xhr);
      }
    });
  }

 

  // Quantity Plus
  $(document).on('click', '.quantity_plus', function () {
  $('div#cart_drawer_content').addClass('loading_hk');
    const input = $(this).siblings('input[name="quantity_single"]');
    let quantity = parseInt(input.val()) + 1;
    input.val(quantity); // Update the input value visually
    const key = input.attr('key');
    const variantId = input.attr('variant_id');
    const sellingPlan = input.attr('selling_plan') || null;

    updateCart(variantId, quantity, key, sellingPlan);
  });

  // Quantity Minus (support 0 to remove item)
  $(document).on('click', '.quantity_minus', function () {
  $('div#cart_drawer_content').addClass('loading_hk');
    const input = $(this).siblings('input[name="quantity_single"]');
    let quantity = parseInt(input.val()) - 1;
    input.val(quantity); // Update the input value visually
    const key = input.attr('key');
    const variantId = input.attr('variant_id');
    const sellingPlan = input.attr('selling_plan') || null;

    // Even if quantity is 0, allow it to remove the item
    updateCart(variantId, quantity, key, sellingPlan);
  });


$(document).on("change", ".recommended_product_quantity select", function (e) {
  var quantity = $(this).val();
$(this).parents('.recommended_product_bottom_flex').find('.recommended_product_button').attr('quantity',quantity);
});
  
$(document).on("click", ".recommended_product_button", function (e) {
  e.preventDefault();
  var $btn = $(this).addClass("loading_hk"),
      id = $btn.attr("variant_id"),
      quantity = $btn.attr("quantity");

  $.post("/cart/add.js", { id, quantity }, function () {
    $.get(window.location.pathname, function (res) {
      var $newContent = $(res).find("#cart_drawer_content");
      $("#cart_drawer_content").replaceWith($newContent);
      $("#cart-drawer").removeClass("is_empty").addClass("open");
      $btn.removeClass("loading_hk");
    });
  }, "json");
});



function updateVh() {
  document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
}
window.addEventListener('resize', updateVh);
window.addEventListener('load', updateVh);

  
  